'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var Checkbox_web = require('../../../atoms/Checkbox/Checkbox.web.cjs');
var Tooltip_web = require('../../../atoms/Tooltip/Tooltip.web.cjs');
var reactFontawesome = require('../../../../react-fontawesome/react-fontawesome.cjs');
var BottomBar_web_styles = require('./BottomBar.web.styles.cjs');

/**
 * Description added in ProductCard.web.tsx
 */ const BottomBar = ({ isHeatSensitive = false, hasShortShelfLife = false, compareTooltipContent, onCompareChange, isCompareChecked = false, isLoading = false, compareAppcuesID })=>{
    const renderCompareCheckbox = ()=>{
        if (!onCompareChange && !isCompareChecked) {
            return null;
        }
        return /*#__PURE__*/ jsxRuntime.jsx(Tooltip_web.Tooltip, {
            tooltipContent: compareTooltipContent ?? "",
            isTooltipHidden: !compareTooltipContent,
            children: /*#__PURE__*/ jsxRuntime.jsx(Checkbox_web.Checkbox, {
                checked: isCompareChecked,
                onChange: onCompareChange,
                disabled: isLoading,
                labelStyle: BottomBar_web_styles.compareCheckbox,
                "data-appcuesid": compareAppcuesID,
                children: "Compare"
            })
        });
    };
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: BottomBar_web_styles.bottomBar,
        children: [
            renderCompareCheckbox(),
            /*#__PURE__*/ jsxRuntime.jsxs("div", {
                css: BottomBar_web_styles.iconContainer,
                children: [
                    isHeatSensitive && /*#__PURE__*/ jsxRuntime.jsx(Tooltip_web.Tooltip, {
                        tooltipContent: "Heat sensitive",
                        children: /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                            icon: index.faTemperatureHalf,
                            css: BottomBar_web_styles.icon
                        })
                    }),
                    hasShortShelfLife && !isLoading && /*#__PURE__*/ jsxRuntime.jsx(Tooltip_web.Tooltip, {
                        tooltipContent: "Short shelf life of 6 months or less",
                        children: /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                            icon: index.faClock,
                            css: BottomBar_web_styles.icon
                        })
                    })
                ]
            })
        ]
    });
};

exports.BottomBar = BottomBar;
//# sourceMappingURL=BottomBar.web.cjs.map
